import * as TyreReturnOrderModels from '../../models/tyre-return-order/tyre-return-order';
import { TyreReturnOrderSearchModel } from '../../models/tyre-return-order/tyre-return-orderSearch';
import * as Models from '../../models/commonModels';



export class GetList {
  static readonly type = '[TyreReturnOrder] List';
  constructor(public Search: TyreReturnOrderSearchModel) { }
}

export class SetSearch {
  static readonly type = '[TyreReturnOrder] Set Search';
  constructor(public Search: TyreReturnOrderSearchModel) { }
}

export class ResetSearch {
  static readonly type = '[TyreReturnOrder] Reset Search';
  constructor() { }
}

export class SetListPage {
  static readonly type = '[TyreReturnOrder] Set List Page';
  constructor(public Search: TyreReturnOrderSearchModel) { }
}

export class Set {
  static readonly type = '[TyreReturnOrder] Set';
  constructor(public Order: Models.Request<TyreReturnOrderModels.TyreReturnOrderModel>) { }
}

export class Get {
  static readonly type = '[TyreReturnOrder] Get';
  constructor(public OrderId: Models.RequestModel) { }
}

export class GetStatusDictionary {
  static readonly type = '[TyreReturnOrder] Get Status Dictionary';
  constructor() { }
}

export class GetFilteredReport {
  static readonly type = '[TyreReturnOrder] GetFilteredReport';
  constructor(public Search: TyreReturnOrderSearchModel) { }
}

export class DisposeSearch {
  static readonly type = '[TyreReturnOrder] DisposeSearch';
  constructor() { }
}
